import React from 'react'
import { withStyles, Grid, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const style = theme => ({
	root: {
		height: theme.components.transferList.row.height,
	},
	labelItem:{
		marginRight: theme.spacing(2),
	},
	childrenItem:{
		flexGrow: '1'
	}
})

function Header({
	classes,
	children,
	title,
	className,
	childClassName,
}) {
	const getLabel = () => {
		if(typeof title === 'string'){
			return (
				<Typography variant='subtitle1'>
					{title}
				</Typography>
			)
		}
		return children;
	}

	return (
		<Grid
			container
			className={clsx(
				classes.root,
				className
			)}
			alignItems='center'
		>
			<Grid item className={classes.labelItem}>
				{getLabel()}
			</Grid>
			<Grid item className={clsx(
				classes.childrenItem,
				childClassName,
			)}>
				{children}
			</Grid>
		</Grid>
	)
}

Header.propTypes = {
	className: PropTypes.string,
	classes: PropTypes.any,
	title: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.func,
	]),
	children: PropTypes.any,
}

Header.defaultProps = {
	className: '',
	childClassName: '',
}

export default withStyles(style)(Header);